"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.LoaderManager = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var LoaderManager = /*#__PURE__*/(0, _createClass2["default"])(function LoaderManager() {
  var _this = this;
  var startLoaderCb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var startLoaderProgressCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var stopLoaderCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  (0, _classCallCheck2["default"])(this, LoaderManager);
  this.start = function () {
    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    _this.startLoaderCb(msg);
  };
  this.progress = function () {
    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var progress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    _this.startLoaderProgressCb(msg, progress);
  };
  this.progressWithTotal = function () {
    var progress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var total = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var ratio = progress / total;
    if (ratio >= 1) ratio = 0;
    _this.progress(null, ratio);
  };
  this.stop = function () {
    _this.stopLoaderCb();
  };
  this.startLoaderCb = startLoaderCb;
  this.startLoaderProgressCb = startLoaderProgressCb;
  this.stopLoaderCb = stopLoaderCb;
});
exports.LoaderManager = LoaderManager;
//# sourceMappingURL=LoaderManager.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/LoaderManager.js
// module id = 1243
// module chunks = 142